



















































































































































































































import ListCard, { ListCardType } from '@/components/ListCard.vue'
import JumpLinks from '@/components/PropertyJumpLinks.vue'
import SingleGmap from '@/components/SingleGmap.vue'
import { EventBus, ON_SHOW_MAP } from '@/eventbus'
import { cardSettingService, jumpLinksService } from '@/services'
import { CardSetting } from '@/types/CardSettingServiceType'
import { JumpLink, StaticJumpLink } from '@/types/JumpLinksType'
import { GmapRecordSetting, StackGmapIconSetting } from '@/types/StackGmapServiceType'
import { Page } from '@/types/enums'
import { GmapRecord } from '@/types/gmapMixinType'
import { formatCurrency, formatLandArea, generateGmapRecord, initGmaps } from '@/utils'
import Vue from 'vue'

export default Vue.extend({
    name: 'PropertyDetail',
    components: {ListCard,JumpLinks,SingleGmap},
    data() {
        let jobTableHeaders = [
            { text: 'Job ID', value: 'jobId' },
            { text: 'Portfolio Number', value: 'portfolioNumber' },
            { text: 'Job Name', value: 'jobName' },
            { text: 'Client', value: 'client' },
            { text: 'Client Company', value: 'clientCompany' },
            { text: 'Status', value: 'status' },
            { text: 'Contract Date', value: 'contractDate' },
            { text: 'Due Date', value: 'dueDate' },
            { text: 'First Invoice Date', value: 'firstInvoiceDate' },
            { text: 'Business Line', value: 'businessLine' },
            { text: 'Appraiser', value: 'appraiser' },
            { text: 'Fee', value: 'fee' },
            { text: 'Reviewer', value: 'reviewer' },
            { text: 'Procurer 1', value: 'procurer1' },
            { text: 'Procurer 2', value: 'procurer2' },
            { text: 'Primary Scope', value: 'primaryScope' },
            { text: 'Primary Format', value: 'primaryFormat' },
            { text: 'Client Reference Number', value: 'clientReferenceNumber' },
        ]

        jobTableHeaders = jobTableHeaders.filter(x => x.value !== 'fee' || this.$store.getters.user.permissions['jobs_fee'])

        return {
            property: {} as any,
            appraisal: {} as any,
            jumpLinkData: [] as JumpLink[],
            showMap: false,
            gmapOptions: {
                page: Page.PROPERTY
            },
            propertyCardSettings: {
                'propertyInfo': false,
                'appraisalInfo': false,
                'contacts': false,
                'additionalDetails':false,
                'leases': false,
                'appraisalJobDetails': false
            } as Record<string,boolean>,
            gmapRecordSetting: {} as GmapRecordSetting,
            gmapIconSetting: {} as StackGmapIconSetting,
            isMapConfigured: false,
            gmapRecord: [] as GmapRecord[],
            jobTableHeaders,
            leasesTableHeaders: [
                { text: 'Business Unit', value: 'businessUnit' },
                { text: 'Floor', value: 'floor' },
                { text: 'Unit', value: 'unit' },
                { text: 'Unit Description', value: 'unitDescription' },
                { text: 'GLA', value: 'gla' },
                { text: 'Lease Id', value: 'leaseId' },
                { text: 'Lease Type', value: 'leaseType' },
                { text: 'Status', value: 'leaseStatus' },
                { text: 'Tenant Id', value: 'tenantId' },
                { text: 'Tenant', value: 'tenantName' },
                { text: 'Expiry Date', value: 'leaseExpiryDate' },
                { text: 'Remaining Lease (Months)', value: 'remainingTermsInMonth' },
                { text: 'Min Rent', value: 'leaseMinRent' },
                { text: 'Monthly Rent', value: 'leaseMonthlyRent' },
                { text: 'Annual Rent', value: 'leaseAnnualRent' },
                { text: 'Deal Type', value: 'futureDealType' },
                { text: 'Deal Stage', value: 'futureDealStage' },
                { text: 'Tenant', value: 'futureTenant' },
                { text: 'LCD', value: 'futureLeaseContractDate' },
                { text: 'Probability', value: 'futureTenantProbability' },
            ],
            page: Page.PROPERTY_INFORMATION,
            staticJumpLinks: [] as StaticJumpLink[],
        }
    },
    async mounted()  {
        await initGmaps.call(this, this.gmapOptions)
        await this.getProperty()
        const propertyCardSettings = await cardSettingService.getCardSettings(Page.PROPERTY_INFORMATION)
        propertyCardSettings.forEach((cardSetting: CardSetting) => {
            if(cardSetting.name in this.propertyCardSettings) {
                this.propertyCardSettings[cardSetting.name] = cardSetting.visibility
            }
        })

        this.jumpLinkData = await jumpLinksService.getJumpLinks(Page.PROPERTY_INFORMATION) ?? []
        this.staticJumpLinks = await jumpLinksService.getStaticJumpLinks(Page.PROPERTY_INFORMATION, this.property.propertyId)

        this.showMap = true

    },
    methods: {
        async getProperty() {
            const propertyID = this.$route.params.propertyID

            const res = await this.axios.get(`/Property/GetProperty/${propertyID}`)

            this.property = res.data

            this.gmapRecord = [generateGmapRecord({
                recordSetting: this.gmapRecordSetting,
                dynamicObj: this.property,
                id: this.property.propertyId,
                gmapIconSetting: this.gmapIconSetting,
                enableUrl: true
            })]
        },
        toggleMap() {
            this.showMap = !this.showMap
        },
        formatCurrency,
        formatLandArea
    },
    computed: {
        // jumpLinkData():any {
        //     return [
        //         {
        //             label:'Ryan Optimus',
        //             value: (()=>{
        //                 const encodeJumpLinkParams = (params:any)=> {
        //                     return encodeURIComponent(encodeURIComponent(JSON.stringify(params)))
        //                 }

        //                 return `https://www.propertytax-software.com/#/parcelSearch/${encodeJumpLinkParams({
        //                     fields: [{
        //                         Alias:'Business Unit',
        //                         Value:this.property.property,
        //                         Operator: 'exact match'
        //                     }],
        //                     rollYear:dayjs().year().toString()
        //                 })}`
        //             })()
        //         },
        //         {
        //             label:'AR Report',
        //             value:`https://chpaz-iis-sql02.corp.creit.ca/ARReport.php?Property=${this.property.property}`,
        //         },
        //         {
        //             label:'Marketing Brochure',
        //             value:this.property.marketingBrochure
        //         },
        //         {
        //             label:'M-Files',
        //             value:this.property.mFilesUrl
        //         },
        //         {
        //             label:'VTS-Deals',
        //             value:(()=>{
        //                 const id = this.property.vtsPropertyId
        //                 if(!id) return ''

        //                 return `https://app.vts.com/portfolio/deals?properties='${id}'&page=1'`

        //             })()
        //         },
        //         {
        //             label:'VTS-Layout',
        //             value: (()=> {
        //                 const id = this.property.vtsPropertyId
        //                 const product = this.property.product

        //                 if(!id || !product) return ''

        //                 const isRetail = product.toUpperCase() === 'RETAIL'
        //                 const path = isRetail ? 'site' : 'stacking'
        //                 return `https://app.vts.com/portfolio/${path}-plan?properties=${id}`

        //             })()
        //         },
        //         {
        //             label:'VTS-Leases',
        //             value: (()=> {
        //                 const id = this.property.vtsPropertyId
        //                 if(!id) return ''

        //                 return `https://app.vts.com/portfolio/leases?properties=${id}`

        //             })()
        //         },
        //         {
        //             label:'Income Statement BI',
        //             value:(()=>{
        //                 if(!this.property.companyGL) return ''

        //                 return `https://app.powerbi.com/groups/me/apps/66bf63cc-3294-45bb-8d1b-6b5f8e54115c/reports/8fac7cd9-6d98-434c-ba3a-57f3867b043d/ReportSection3de6237ef9fe6ea50a48?filter=businessunit/company eq '${this.property.companyGL}'`
        //             })()
        //         },
        //         {
        //             label:'Unit Inventory BI',
        //             value:(()=>{
        //                 if(!this.property.company) return ''

        //                 return `https://app.powerbi.com/groups/me/apps/66bf63cc-3294-45bb-8d1b-6b5f8e54115c/reports/71438d42-bd58-4320-9d8a-1c2942da289c/ReportSection?filter=AbsorptionQuarterly~2FPROPERTYCODE eq '${this.property.company}'`
        //             })(),
        //         },
        //         {
        //             label:'Rent Roll (Net Change) Report',
        //             value:`https://chpaz-iis-sql02.corp.creit.ca/rentrollreport.php?Property=${this.property.property}`,
        //         },
        //         {
        //             label:'External Webpage En',
        //             value:this.property.leaseListingUrlEn,
        //         },
        //         {
        //             label:'External Webpage Fr',
        //             value:this.property.leaseListingUrlFr,
        //         },
        //         {
        //             label:'Leasing Brochure En',
        //             value:this.property.leasePdfUrlEn,
        //         },
        //         {
        //             label:'Leasing Brochure Fr',
        //             value:this.property.leasePdfUrlFr,
        //         },
        //         {
        //             label:'Roof Leaks',
        //             value:`https://app.powerbi.com/groups/me/reports/76b224c6-9a8e-44f6-a966-6cf9afd08437/ReportSection491b18420448e000e9c4?filter=BU/company eq ${this.property.property}`,
        //         },
        //         ...this.$store.state.setting.jumpLinks
        //             .filter((o:any)=>o.location==='property')
        //             .filter((o:any)=>{
        //                 return !o.parts
        //                     .filter((part:any)=>part.type==='dropdown')
        //                     .map((part:any)=>!!part.value)
        //                     .some((boolean: any)=>!boolean)
        //             })
        //             .map((o: { parts: any[] })=>{
        //                 return {...o,parts:o.parts.map((part: { type: string; value: string|number })=>{

        //                     if(part.type === 'text') return part.value
        //                     if(part.type === 'dropdown') return this.property[part.value]
        //                 }).join('')
        //                 }
        //             }).map((o: { label: any; parts: any })=>{
        //                 return {
        //                     label:o.label,
        //                     value:o.parts
        //                 }
        //             })
        //     ]
        // },
        propertyInfo():ListCardType {
            return [
                {
                    label: 'Company',
                    value: this.property.company,
                    method: 'quickFilter',
                    name:'Company'

                },
                {
                    label: 'Correlated Company',
                    value: this.property.correlatedCompany,
                    method:'quickFilter',
                    name:'Correlated Company'
                },
                {
                    label:'Business Unit',
                    value:this.property.businessUnit,
                },
                {
                    label:'Property Name',
                    value:this.property.propertyName,
                },
                {
                    label:'Address',
                    value: this.property.address,

                },
                {
                    label:'Postal Code',
                    value:this.property.postalCode,
                },
                {
                    label:'City',
                    value:this.property.city,
                    method:'quickFilter',
                    name:'City'
                },
                {
                    label:'State',
                    value:this.property.state,
                    method: 'quickFilter',
                    name:'State'
                },
                {
                    label:'County',
                    value:this.property.county,
                    method: 'quickFilter',
                    name:'County'
                },
                {
                    label:'Country',
                    value:this.property.country,
                    method:'quickFilter',
                    name:'Country'

                },
                {
                    label:'Region',
                    value:this.property.region,
                    method:'quickFilter',
                    name:'Region'

                },
                {
                    label:'Asset Class',
                    value:this.property.assetClass,
                    method:'quickFilter',
                    name:'Asset Class'
                },
                {
                    label:'Sub Asset Class',
                    value:this.property.subAssetClass,
                    method:'quickFilter',
                    name:'Sub Asset Class'
                },
                {
                    label:'Building Classification',
                    value:this.property.buildingClassification,
                    method:'quickFilter',
                    name:'Building Classification'
                },
                {
                    label:'GLA',
                    value: this.formatLandArea(this.property.gla, this.property.landUnit),
                    type:'number'
                },
                {
                    label: 'Company General Ledger',
                    value: this.property.companyGL,
                }
            ]
        },
        appraisalInfo():ListCardType {
            return [
                {
                    label: 'Property NRA',
                    value: this.property.propertyNRA
                },
                {
                    label: 'Property GBA',
                    value: this.property.propertyGBA
                },
                {
                    label: 'Job Number',
                    value: this.property.jobNumber
                },
                {
                    label: 'Primary Appraiser',
                    value: this.property.primaryAppraiser
                },
                {
                    label:'Role',
                    value:this.property.role
                },
                {
                    label:'Due Date',
                    value:this.property.dueDate
                },
                {
                    label:'Delivery Date',
                    value: this.property.deliveryDate
                },
                {
                    label:'Fee',
                    value:this.property.fee,
                    type: 'currency'
                },
                {
                    label:'Report Format',
                    value:this.property.reportFormat
                },
                {
                    label:'Primary Use',
                    value:this.property.primaryUse
                },
                {
                    label:'Reviewer',
                    value:this.property.reviewer
                },
                {
                    label:'Trainee',
                    value:this.property.trainee
                },
                {
                    label:'Status',
                    value:this.property.status
                }
            ]
        },
        contacts(): ListCardType {
            var contacts = this.property?.contacts?.map( (contact:any) => ({
                label: contact.roleName,
                value: contact.fullName,
                dialog: [
                    {
                        label:'Email',
                        value: contact.email,
                    },
                    {
                        label:'Work Phone',
                        value: contact.workPhone,
                    },
                    {
                        label:'Cell Phone',
                        value: contact.cellPhone,
                    },
                    {
                        label:'Direct Phone',
                        value: contact.directPhone,
                    },
                ]
            }))

            contacts.push({
                label: 'Property Group',
                value: this.property.propertyGroup,
                method: 'quickFilter',
                name: 'Property Group'
            })

            contacts.push({
                label: 'Property Group Description',
                value: this.property.propertyGroupDescription,
                method: 'quickFilter',
                name: 'Property Group Description'
            })

            return contacts
        },
        additionalDetails(): ListCardType {
            let entities = this.property.entities.map((entity:any) => ({
                label: entity.entityType,
                value: entity.name,
                method: 'quickFilter',
                name: entity.entityType,
                dialog: entity.taxes.map((tax:any) => ({
                    label: tax.taxType,
                    value: tax.taxRegistrationNumber
                }))
            }))

            let owners = this.property.owners.map((owner:any) => ({
                label: owner.type,
                value: owner.name,
                dialog: [
                    {
                        label: 'IPP Accounting',
                        value: owner.ipp,
                    },
                    {
                        label: 'PUD Accounting',
                        value: owner.pud,
                    },
                    {
                        label: 'Leasing',
                        value: owner.leasing,
                    },
                ]
            }))

            let result = entities.concat(owners)
            let propertyOwner = this.property.owners.find( (owner:any) => owner.type === 'Owner')

            if(propertyOwner) {
                result = result.concat([
                    {
                        label: 'Ownership Percentage',
                        value: propertyOwner.ownershipPercentage,
                        type: 'percentage'
                    },
                
                    {
                        label:'Owned GLA',
                        value: formatLandArea(propertyOwner.ownedGla, this.property.landUnit),
                    },
                    {
                        label:'Occupancy Area',
                        value: formatLandArea(propertyOwner.occupancyArea, this.property.landUnit),
                    },
                    {
                        label:'Occupancy %',
                        value: propertyOwner.occupancyPercentage,
                        type: 'percentage'
                    },
                    {
                        label:'Owned Vacant GLA',
                        value: formatLandArea(propertyOwner.ownedVacantGla, this.property.landUnit),
                    },
                    {
                        label:'Vacancy %',
                        value: propertyOwner.ownedVacancyPercentage,
                        type: 'percentage'
                    },
                ])
            }

            return result
        }
    },
    watch: {
        showMap(newValue) {
            if(newValue) {
                EventBus.$emit(ON_SHOW_MAP)
            }
        }
    }
})
